import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

export default function FounderStrip() {
  return (
    <section
      data-testid="founder-strip"
      className="px-6 lg:px-12 pb-24 lg:pb-32 -mt-8 lg:-mt-12"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal>
          <Link
            to="/who-am-i"
            data-testid="founder-strip-link"
            aria-label="About Amit Parikh — Founder and Field CTO, Tech Executive Capability Center"
            className="group flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-10 border border-white/10 bg-white/[0.02] px-6 lg:px-10 py-8 hover:bg-white/[0.04] hover:border-[#E6E4D9]/30 transition-colors duration-500"
          >
            <img
              src="/founder.png"
              alt="Amit Parikh, Founder and Field CTO of TECC"
              className="w-20 h-20 lg:w-24 lg:h-24 object-cover object-top border border-white/10 shrink-0"
            />
            <div className="flex-1">
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/40 mb-2">
                The Principal
              </p>
              <p className="font-serif text-2xl sm:text-3xl text-white tracking-tight">
                Amit Parikh{" "}
                <span className="italic text-[#E6E4D9]">
                  — Founder &amp; Field CTO
                </span>
              </p>
              <p className="mt-3 text-sm font-light leading-relaxed text-white/60 max-w-2xl">
                Nearly three decades in enterprise technology, most recently
                Field CTO at Quest Software. Every blueprint on this site is
                his work — the architecture, the room, and the outcome.
              </p>
            </div>
            <span className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 group-hover:text-[#E6E4D9] transition-colors duration-300 shrink-0">
              Who I Am
              <ArrowUpRight
                size={14}
                weight="bold"
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </span>
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
